import React, { useState } from 'react';
import { ConfirmDialog } from '@monorepo/common';
import { CPGJOBS_SITE_URL } from './cpgSites';
import cpgJobsLogo from '../../assets/CPGJobs-Logo.svg';
import { allowLeavingPage } from '../LeavePageGuard';

// Env-aware cpgjobs home (prod www.cpgjobs.com, dev localhost:3106 — see cpgSites.ts).
const CPGJOBS_HOME_URL = CPGJOBS_SITE_URL;

// CPG Jobs logo lockup (official brand mark + wordmark, src/assets/CPGJobs-Logo.svg).
// Links out to the cpgjobs app behind a leave-confirmation — these pages are the
// purchase transaction, and a same-tab exit abandons an in-progress listing.
// Modified/middle clicks skip the dialog: they open a new tab, so nothing is lost.
export const CpgJobsLogo = () => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    setConfirmOpen(true);
  };

  const handleConfirm = (confirmed: boolean) => {
    if (!confirmed) return;
    // The dialog above already asked, so a page's leave guard should not ask again.
    allowLeavingPage();
    window.location.assign(CPGJOBS_HOME_URL);
  };

  return (
    <>
      <a
        href={CPGJOBS_HOME_URL}
        className="cpgjobs-logo"
        aria-label="CPG Jobs by BevNET CPG Media"
        onClick={handleClick}
      >
        <img className="cpgjobs-logo-img" src={cpgJobsLogo} alt="" />
      </a>
      <ConfirmDialog
        open={confirmOpen}
        setOpen={setConfirmOpen}
        setConfirm={handleConfirm}
        confirmTitle="Leave this page?"
        confirmText="You're heading to CPGJobs.com. Any information you've entered on this page will be lost."
        yesButtonText="Leave"
        noButtonText="Stay here"
      />
    </>
  );
};

export default CpgJobsLogo;
